module.exports = __webpack_public_path__ + "img/logos/loom-logo-fa5e85c7e384326b7e356a80c07db26f.png";